'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import usageTracker from '../../lib/usageTracker';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import AlertMessage from '../AlertMessage';
import Logo from '../Logo';
import HomepageForm from '../HomepageForm';
import LanguageSwitcher from '../LanguageSwitcher';
import DocumentHead from '../portals/DocumentHead';
import Canonical from '../Canonical';
import Hreflang from '../Hreflang';
import Languages from '../../constants/Languages';
import { getLocalizedUrl } from '../../util/Urls';
var languages = Object.keys(Languages);
export default (function (_ref) {
  var location = _ref.location,
      url = _ref.match.url;
  useEffect(function () {
    usageTracker.logView('Home');
  }, []);

  var renderWelcomeBanner = function renderWelcomeBanner() {
    switch (location.search) {
      case 'producthunt':
        return /*#__PURE__*/_jsx(AlertMessage, {
          message: "home.productHuntMessage"
        });

      case 'mg':
        return /*#__PURE__*/_jsx(AlertMessage, {
          message: "home.marketingGraderMessage"
        });

      default:
    }

    return undefined;
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "home-page",
    children: [/*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx(Canonical, {
        to: url
      }), /*#__PURE__*/_jsx(Hreflang, {
        href: getLocalizedUrl('en'),
        lang: "x-default"
      }), languages.map(function (lang) {
        return /*#__PURE__*/_jsx(Hreflang, {
          href: getLocalizedUrl(lang),
          lang: lang
        }, lang);
      })]
    }), /*#__PURE__*/_jsxs("div", {
      children: [renderWelcomeBanner(), /*#__PURE__*/_jsx(LanguageSwitcher, {}), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx("h1", {
        className: "title",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "meta.title"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "subtitle",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "home.title"
        })
      }), /*#__PURE__*/_jsx(HomepageForm, {})]
    })]
  });
});